export default __webpack_public_path__ + "static/media/korean.f19d0bac.webp";